<div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white" *ngIf="isStandalone">
  <app-breadcrum [data]="wishlistBreadcrumbs"></app-breadcrum>
</div>
<div class="w-full inline-flex flex-col justify-start items-start gap-4 md:gap-6" [class.px-4]="isStandalone"
  [class.sm:px-6]="isStandalone" [class.lg:px-8]="isStandalone">
  <!-- Title Section -->
  <div class="self-stretch inline-flex justify-between items-center">
    <div class="flex-1 flex justify-start items-center gap-1">
      <div class="justify-start text-black text-2xl font-bold leading-loose max-sm:text-xl">
        My Wishlist
      </div>
      <div class="justify-start text-gray-500 text-base font-medium leading-normal max-sm:text-sm">
        -
      </div>
      <div class="justify-start text-gray-500 text-lg font-medium leading-normal max-sm:text-base">
        {{ wishlistItems.length || 0 }} products
      </div>
    </div>
  </div>

  <!-- Desktop Layout: Filters/Sort on left, Search on right -->
  <div class="hidden md:flex self-stretch h-8 inline-flex justify-between items-center">
    <div class="flex justify-start items-center gap-3 cursor-pointer">
      <div class="flex justify-start items-center gap-3">
        <!-- Desktop Sort Dropdown -->
        <div class="relative inline-block w-25">
          <button data-sort-button
            class="w-full flex justify-between items-center px-3 py-2 gap-4 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 whitespace-nowrap hover:bg-gray-50 h-8"
            (click)="openDesktopSortDropdown()">
            {{ getSortOptionLabel(selectedSortOption) || "Sort By" }}
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="sort-icon" style="width: 20px; height: 20px; flex-shrink: 0">
              <path d="M2 16.25L6 16.25M2 10.25L10 10.25M2 4.25L14 4.25" stroke="black" stroke-width="1.5"
                stroke-linecap="round"></path>
            </svg>
          </button>

          <!-- Desktop Dropdown Menu -->
          <div *ngIf="showDesktopSortDropdown"
            class="absolute mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-50">
            <div class="py-1">
              <button *ngFor="let option of sortOptions"
                class="w-full text-left py-2 text-sm text-gray-700 hover:bg-gray-100"
                (click)="selectSortOptionAndClose(option.value)">
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>

        <!-- Desktop Filter Dropdown -->
        <div class="relative inline-block w-28">
          <button data-filter-button
            class="w-full flex justify-between items-center px-3 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 whitespace-nowrap hover:bg-gray-50 h-8"
            (click)="openDesktopFilterDropdown()">
            {{ getFilterOptionLabel(selectedFilterOption) || "All" }}
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Desktop Filter Dropdown Menu -->
          <div *ngIf="showDesktopFilterDropdown"
            class="absolute mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-50">
            <div class="py-1">
              <button *ngFor="let option of filterOptions"
                class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                (click)="selectFilterOptionAndClose(option.value)">
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-full max-w-xs h-8 p-2 rounded-md outline outline-1 outline-offset-[-1px] outline-Input-field-Stroke flex justify-between items-center">
      <div class="flex justify-center items-center gap-2.5">
        <input [(ngModel)]="searchTerm" (input)="searchWishlist()"
          class="justify-start focus:outline-none text-Text-Caption text-sm font-medium leading-tight w-full"
          placeholder="Search added parts or scrap" />
      </div>
      <div data-icon="Search" class="w-5 h-5 relative overflow-hidden cursor-pointer flex-shrink-0">
        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="w-5 h-5">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
    </div>
  </div>

  <!-- Mobile Layout: Search bar first, then filters side by side -->
  <div class="md:hidden flex flex-col gap-3 w-full">
    <!-- Search Bar -->
    <div
      class="w-full h-10 p-2 rounded-md outline outline-1 outline-offset-[-1px] outline-Input-field-Stroke flex justify-between items-center bg-white">
      <div class="flex justify-center items-center gap-2.5 flex-1">
        <input [(ngModel)]="searchTerm" (input)="searchWishlist()"
          class="justify-start focus:outline-none text-Text-Caption text-sm font-medium leading-tight w-full bg-transparent"
          placeholder="Search added parts or scrap" />
      </div>
      <div data-icon="Search" class="w-5 h-5 relative overflow-hidden cursor-pointer flex-shrink-0">
        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="w-5 h-5">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
    </div>

    <!-- Sort and Filter Dropdowns Side by Side -->
    <div class="flex justify-start items-center gap-3 w-full">
      <!-- Mobile Sort Button -->
      <div
        class="flex-1 h-10 pl-3 pr-2 py-1 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-Input-field-Stroke flex justify-between items-center gap-1 cursor-pointer"
        (click)="openSortPopup()">
        <div class="justify-start text-Text-Black text-sm font-medium leading-tight">
          Sort By
        </div>
        <div data-icon="Sort By" class="w-5 h-5 relative overflow-hidden flex-shrink-0">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="sort-icon" style="width: 20px; height: 20px; flex-shrink: 0">
            <path d="M2 16.25L6 16.25M2 10.25L10 10.25M2 4.25L14 4.25" stroke="black" stroke-width="1.5"
              stroke-linecap="round"></path>
          </svg>
        </div>
      </div>

      <!-- Mobile Filter Button -->
      <div
        class="flex-1 h-10 pl-3 pr-2 py-1 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-Input-field-Stroke flex justify-between items-center gap-1 cursor-pointer"
        (click)="openFilterPopup()">
        <div class="justify-start text-Text-Black text-sm font-medium leading-tight capitalize">
          {{ getFilterOptionLabel(selectedFilterOption) || "All" }}
        </div>
        <div data-icon="Chevron-down" class="w-5 h-5 relative overflow-hidden cursor-pointer flex-shrink-0">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="chevron-icon" style="width: 20px; height: 20px">
            <path d="M1 1.75L5.41074 6.16074C5.73618 6.48618 6.26382 6.48618 6.58926 6.16074L11 1.75" stroke="black"
              stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <!-- <div *ngIf="!products || products.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
    <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-4 opacity-50">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <h3 class="text-xl font-bold text-gray-700 mb-2">Your Wishlist is Empty</h3>
    <p class="text-gray-500 mb-4">Add products to your wishlist to save them for later</p>
    <a routerLink="/product-list" class="px-6 py-3 bg-blue-950 text-white font-bold rounded-lg hover:bg-blue-900 transition-colors">Browse Products</a>
  </div> -->

  <div class="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 lg:gap-6 w-full" *ngIf="products && products.length > 0">
    <article *ngFor="let product of products"
      class="wishlist-card flex flex-col bg-white rounded-lg overflow-hidden border border-transparent hover:border-gray-100 hover:shadow-md transition-shadow min-w-0">
      <div class="relative w-full aspect-[4/3] sm:aspect-auto sm:h-[180px] lg:h-[231px] bg-zinc-100 overflow-hidden">
        <img [src]="
            product?.part_image_path[0]
              ? product?.part_image_path[0]
              : product?.part_image_path
          " [alt]="product | productName" (click)="gotoProductDetails(product)"
          class="object-cover size-full cursor-pointer" />
        <div class="absolute top-2 left-2 z-[1]">
          <div *ngIf="product?.quality_s" class="flex gap-1 items-center px-1 py-0.5 rounded" [ngClass]="
              product?.quality_s === 'A'
                ? 'bg-green-100 text-green-800'
                : product?.quality_s === 'B'
                  ? 'bg-yellow-100 text-yellow-800'
                  : product?.quality_s === 'C'
                    ? 'bg-orange-100 text-orange-800'
                    : 'bg-green-100 text-green-800'
            ">
            <div>
              <!-- {{ product?.quality_s}} -->
              <svg *ngIf="product?.quality_s" [attr.title]="'Quality grade: ' + product.quality_s" width="24"
                height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 md:w-6 md:h-6">
                <!-- Background rectangle with rounded corners -->
                <rect width="24" height="24" rx="4" [attr.fill]="
                    product?.quality_s === 'A'
                      ? '#01811D'
                      : product?.quality_s === 'B'
                        ? '#B8860B'
                        : product?.quality_s === 'C'
                          ? '#D35400'
                          : '#01811D'
                  " />

                <!-- Dynamic letter inside the SVG -->
                <text [attr.x]="12" [attr.y]="16" text-anchor="middle" font-size="14" font-family="Arial, sans-serif"
                  fill="white">
                  {{ product.quality_s }}
                </text>
              </svg>
            </div>
            <span class="text-xs sm:text-sm md:text-base font-bold" [ngClass]="
                product?.quality_s === 'A'
                  ? 'text-green-800'
                  : product?.quality_s === 'B'
                    ? 'text-yellow-800'
                    : product?.quality_s === 'C'
                      ? 'text-orange-800'
                      : 'text-green-800'
              ">
              Quality
            </span>
          </div>
        </div>
        <button type="button" class="absolute top-2 right-2 z-[2] text-gray-500 hover:text-red-500"
          (click)="removeFromWishlist(product)" aria-label="Remove from wishlist">
          <svg width="36" height="36" viewBox="0 4 30 43" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="w-8 h-8 md:w-10 md:h-10">
            <g filter="url(#filter0_d_1993_8664)">
              <circle cx="19.6914" cy="19.8516" r="16" fill="white" />
            </g>
            <path d="M25 15.25L20 20.25L15 25.25M15 15.25L20 20.25L25 25.25" stroke="black" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
            <defs>
              <filter id="filter0_d_1993_8664" x="0.711711" y="0.871867" width="41.9323" height="41.9323"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dx="1.98646" dy="1.98646" />
                <feGaussianBlur stdDeviation="2.48308" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1993_8664" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1993_8664" result="shape" />
              </filter>
            </defs>
          </svg>
        </button>
        @if ((product?.stock_quantity_s ?? 0) <= 0) { <div
          class="absolute inset-0 flex items-center justify-center z-[1] bg-black/10">
          <span class="px-3 py-1 text-sm md:text-base font-bold text-white rounded-lg opacity-90 bg-zinc-700">
            Out of stock
          </span>
      </div>
      }
  </div>
  <div class="flex flex-col gap-1.5 p-2 sm:p-3 w-full flex-1 min-h-0 cursor-pointer">
    <h3 class="text-base font-bold text-black max-sm:text-sm md:text-base text-ellipsis-1-line"
      (click)="gotoProductDetails(product)">
      {{ product | productName }}
    </h3>
    @if (product?.part_type === "Used Part") {
    <div class="flex flex-wrap gap-1 items-center text-[10px] sm:text-[11px] leading-[14px] text-neutral-600"
      (click)="gotoProductDetails(product)">
      <span *ngIf="product?.make">{{ product?.make }}</span>
      <span *ngIf="product?.make">•</span>
      <span *ngIf="product?.model">{{
        product?.model | slice: 0 : 10
        }}</span>
      <span *ngIf="product?.model">•</span>
      <span *ngIf="product?.year_of_manufacture">{{
        product?.year_of_manufacture
        }}</span>
      <span *ngIf="product?.year_of_manufacture">•</span>
      <span *ngIf="product?.variant">{{
        product?.variant | slice: 0 : 10
        }}</span>
    </div>
    <div class="flex gap-2 items-center max-sm:gap-1 max-sm:overflow-x-auto max-sm:flex-nowrap"
      (click)="gotoProductDetails(product)">
      <span class="text-base font-bold text-black max-sm:text-xs md:text-base whitespace-nowrap">
        ₹{{
        product?.discounted_price
        ? product?.discounted_price?.toLocaleString()
        : product?.price_s?.toLocaleString()
        }}
      </span>
      <span class="text-base font-medium line-through text-neutral-500 max-sm:text-xs md:text-base whitespace-nowrap"
        *ngIf="product?.discounted_price && product?.price_s">
        ₹{{ product?.price_s?.toLocaleString() }}
      </span>
      <div
        class="px-2 py-1 h-6 text-xs font-bold text-white bg-emerald-800 rounded-2xl max-sm:text-[10px] max-sm:h-5 max-sm:py-0 max-sm:px-1 md:text-xs md:h-6 whitespace-nowrap"
        *ngIf="
                product?.discount_percentage && product?.discount_percentage > 0
              ">
        {{ product?.discount_percentage }}% Off
      </div>
    </div>
    @if (product?.is_locked) {
    <section class="flex relative gap-2 items-start w-full" role="alert" aria-live="polite">
      <div class="flex relative flex-col shrink-0 justify-center items-center px-0 py-0.5 w-4 h-5">
        <div class="absolute left-0 top-0.5 shrink-0 w-4 h-4">
          <div
            class="absolute left-px shrink-0 text-xs bg-red-600 rounded-full font-bold h-[15px] text-white top-[3px] w-[15px] flex items-center justify-center">
            i
          </div>
        </div>
      </div>
      <p class="relative text-[10px] sm:text-sm font-medium leading-4 sm:leading-5 text-red-600 flex-1 line-clamp-2">
        This part is no longer available for purchase.
      </p>
    </section>
    }
    <div class="flex flex-col gap-1 sm:gap-1.5 w-full xl:flex-row xl:justify-between xl:items-center">
      <div class="flex gap-1.5 sm:gap-2 items-center min-w-0">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4 sm:w-5 sm:h-5 shrink-0">
          <path
            d="M11.6666 15V8.33333M11.6666 15H13.3333M11.6666 15H8.74996M4.16663 15H5.41663M11.6666 8.33333V5.83333C11.6666 5.3731 11.2935 5 10.8333 5H4.16663C3.70639 5 3.33329 5.3731 3.33329 5.83333V7.5M11.6666 8.33333H15.1429C15.585 8.33333 16.0089 8.50893 16.3214 8.82149L17.8451 10.3452C18.1577 10.6577 18.3333 11.0817 18.3333 11.5237V14.1667C18.3333 14.6269 17.9602 15 17.5 15H16.6666M8.74996 15C8.74996 15.9205 8.00377 16.6667 7.08329 16.6667C6.16282 16.6667 5.41663 15.9205 5.41663 15M8.74996 15C8.74996 14.0795 8.00377 13.3333 7.08329 13.3333C6.16282 13.3333 5.41663 14.0795 5.41663 15M16.6666 15C16.6666 15.9205 15.9204 16.6667 15 16.6667C14.0795 16.6667 13.3333 15.9205 13.3333 15M16.6666 15C16.6666 14.0795 15.9204 13.3333 15 13.3333C14.0795 13.3333 13.3333 14.0795 13.3333 15M3.33329 7.5H6.66663M3.33329 7.5H1.66663M8.33329 10H3.33329M3.74996 12.5H2.49996"
            stroke="#307FE1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <span class="text-[10px] sm:text-xs font-medium text-black leading-tight">Delivery by
          <span class="font-bold">{{ getDeliveryDate() }}</span></span>
      </div>
      <div class="flex gap-1.5 sm:gap-2 items-center min-w-0">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4 sm:w-5 sm:h-5 shrink-0">
          <path
            d="M16.0869 8.93384V15C16.0869 16.3807 14.919 17.5 13.4782 17.5H12.1739M16.0869 8.93384C16.4191 8.76991 16.7513 8.52197 17.035 8.27813C17.5483 7.83698 17.627 7.11852 17.3187 6.52752L15.9384 3.88197C15.4965 3.03501 14.5932 2.5 13.6051 2.5H6.3949C5.4068 2.5 4.50351 3.03501 4.06162 3.88197L2.68134 6.52752C2.373 7.11852 2.45168 7.83698 2.96498 8.27813C3.24869 8.52197 3.58089 8.76991 3.91309 8.93384M16.0869 8.93384C15.8016 9.07464 15.5051 9.16667 15.2174 9.16667C13.4782 9.16667 12.6087 7.5 12.6087 7.5C12.6087 7.5 11.7391 9.16667 10 9.16667C8.26088 9.16667 7.39132 7.5 7.39132 7.5C7.39132 7.5 6.52176 9.16667 4.78264 9.16667C4.49494 9.16667 4.19841 9.07464 3.91309 8.93384M3.91309 8.93384V15C3.91309 16.3807 5.08103 17.5 6.52176 17.5H7.8261M7.8261 17.5V13.3333C7.8261 12.8731 8.21542 12.5 8.69566 12.5H11.3043C11.7846 12.5 12.1739 12.8731 12.1739 13.3333V17.5M7.8261 17.5H12.1739"
            stroke="#307FE1" stroke-width="1.5" stroke-linejoin="round"></path>
        </svg>
        <span class="text-[10px] sm:text-xs font-medium text-black leading-tight">
          Store pickup ready
        </span>
      </div>
    </div>
    }
    <div class="flex flex-col gap-1 text-sm" *ngIf="product?.part_type === 'Scrap Part'">
      <p class="text-gray-600 text-xs sm:text-sm">
        Seller:
        <span class="text-[#0A0A5F] text-xs sm:text-sm font-bold">{{
          product?.seller_name
          }}</span>
      </p>
      <div class="flex flex-wrap items-center gap-1.5 sm:gap-2">
        <p class="text-black text-sm sm:text-base font-bold leading-5">
          ₹{{
          product?.discounted_taxable
          ? product?.discounted_taxable
          : product?.taxable_amount
          }}/Kg
        </p>
        <p class="text-[#777] line-through text-xs font-medium" *ngIf="product?.discount_percentage > 0">
          ₹{{ product?.taxable_amount }}
        </p>
        <span
          class="inline-flex items-center justify-center px-1.5 py-0.5 rounded-2xl bg-[#006C3B] text-white text-[10px] font-bold whitespace-nowrap"
          *ngIf="
                product?.discount_percentage && product?.discount_percentage > 0
              ">
          {{ product?.discount_percentage }}% off
        </span>
      </div>

      <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-gray-500 mt-[4px]">
        <p>
          Min Booking Qty:
          <span class="text-black text-[13px] font-bold leading-[18px]">
            <ng-container *ngIf="product.selectedUnit === 'kg'">{{
              product?.min_quantity || product?.min_qty || 0
              }}
              kg</ng-container>
            <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
              (product?.min_quantity || product?.min_qty || 0) / 1000
              }}
              ton</ng-container>
            <ng-container *ngIf="product.selectedUnit === 'liter'">{{
              product?.min_quantity || product?.min_qty || 0
              }}
              liter</ng-container>
          </span>
        </p>
        <p>
          Max Booking Qty:
          <span class="text-black text-[13px] font-bold leading-[18px]">
            <ng-container *ngIf="product.selectedUnit === 'kg'">{{
              product?.max_booking_qty ||
              product?.max_booking_quantity ||
              product?.max_quantity ||
              product?.available_quantity ||
              product?.fix_quantity ||
              0
              }}
              kg</ng-container>
            <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
              (product?.max_booking_qty ||
              product?.max_booking_quantity ||
              product?.max_quantity ||
              product?.available_quantity ||
              product?.fix_quantity ||
              0) / 1000
              }}
              ton</ng-container>
            <ng-container *ngIf="product.selectedUnit === 'liter'">{{
              product?.max_booking_qty ||
              product?.max_booking_quantity ||
              product?.max_quantity ||
              product?.available_quantity ||
              product?.fix_quantity ||
              0
              }}
              liter</ng-container>
          </span>
        </p>
      </div>

      <div class="product-card-qty-box mt-1">
        <!-- Quantity input/select based on unit -->
        <div *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'" class="flex flex-1 min-w-0">
          <!-- Show select dropdown when not in custom mode -->
          <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
            [value]="product.quantity || ''" class="qty-dropdown">
            <option value="">Select any one</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="custom">Custom</option>
          </select>
          <!-- Show input field when custom is selected -->
          <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter custom quantity"
            [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
            (blur)="onQuantityBlur(product)" [id]="'customInput-' + product.part_number" class="qty-input" min="1"
            step="0.1" #customInput />
        </div>

        <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
          <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
            (input)="onKgQuantityChange(product, $event)" class="qty-input" />
        </div>

        <div class="unit-divider"></div>

        <!-- Unit select -->
        <select (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'" class="unit-dropdown">
          <option value="ton">ton</option>
          <option value="kg">kg</option>
        </select>
      </div>

      <!-- Error messages for quantity validation -->
      <div *ngIf="
              product?.part_type === 'Scrap Part' &&
              product.quantityTouched &&
              (getSelectedQuantity(product) === 0 ||
                getSelectedQuantity(product) === null ||
                getSelectedQuantity(product) === undefined)
            " class="text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
        Please select a quantity
      </div>
      <div *ngIf="
              product?.part_type === 'Scrap Part' &&
              product.quantityTouched &&
              getSelectedQuantity(product) > 0 &&
              getSelectedQuantity(product) <
                (product?.min_quantity || product?.min_qty || 0)
            " class="text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
        Minimum quantity is
        <span *ngIf="product.selectedUnit === 'kg'">{{ product?.min_quantity || product?.min_qty || 0 }} kg</span><span
          *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{ (product?.min_quantity || product?.min_qty
          || 0) / 1000 }} ton</span><span *ngIf="product.selectedUnit === 'liter'">{{ product?.min_quantity ||
          product?.min_qty || 0 }} ltr</span>
      </div>
      <div *ngIf="
              product?.part_type === 'Scrap Part' &&
              product.quantityTouched &&
              getSelectedQuantity(product) > 0 &&
              getSelectedQuantity(product) >
                (product?.max_booking_qty ||
                  product?.max_booking_quantity ||
                  product?.max_quantity ||
                  product?.available_quantity ||
                  product?.fix_quantity ||
                  0)
            " class="text-[#e85e5e] text-[12px] font-medium leading-[16px] font-['Uni Neue'] mt-2">
        Maximum available quantity is
        <span *ngIf="product.selectedUnit === 'kg'">{{
          product?.max_booking_qty ||
          product?.max_booking_quantity ||
          product?.max_quantity ||
          product?.available_quantity ||
          product?.fix_quantity ||
          0
          }}
          kg</span><span *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
          (product?.max_booking_qty ||
          product?.max_booking_quantity ||
          product?.max_quantity ||
          product?.available_quantity ||
          product?.fix_quantity ||
          0) / 1000
          }}
          ton</span><span *ngIf="product.selectedUnit === 'liter'">{{
          product?.max_booking_qty ||
          product?.max_booking_quantity ||
          product?.max_quantity ||
          product?.available_quantity ||
          product?.fix_quantity ||
          0
          }}
          ltr</span>
      </div>
    </div>
    <div class="flex flex-row gap-1.5 sm:gap-2 items-stretch w-full mt-auto pt-2">
      <!-- Buy/Book Now Button -->
      @if ((product?.stock_quantity_s ?? 0) >= 1) {
      <app-buy-now-button [productData]="product" [isLocked]="product?.is_locked" (buyNowClicked)="onBuyNow(product)"
        (paymentSuccess)="onPaymentSuccess($event)" class="flex-1 min-w-0">
      </app-buy-now-button>
      <button [disabled]="product?.is_locked"
        class="cart-btn flex items-center justify-center gap-0.5 px-1 py-2 w-full flex-1 min-w-0 whitespace-nowrap bg-blue-500 rounded-lg min-h-8 sm:min-h-9 lg:min-h-10 text-[10px] sm:text-xs lg:text-sm"
        [class.added]="itemAddedToCart.get(product?.inventory_id)" [class.disabled]="product?.is_locked" (click)="
                itemAddedToCart.get(product?.inventory_id)
                  ? goToCartWithEvent($event)
                  : addToCart($event, product)
              ">
        <div class="cart-content cart-content-add">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
            class="cart-icon-svg">
            <rect width="20" height="20" transform="translate(0.5)" fill="none" />
            <path
              d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
              fill="white" />
          </svg>
          <span class="btn-text font-bold text-white">Add to Cart</span>
        </div>
        <div class="cart-content cart-content-go">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
            class="cart-icon-svg">
            <path
              d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
              fill="white" />
          </svg>
          <span class="btn-text font-bold text-white">Go to Cart</span>
        </div>
      </button>
      }
      @if ((product?.stock_quantity_s ?? 0) <= 0) { <button
        class="flex gap-1 justify-center items-center w-full px-2 sm:px-3 py-2 text-xs sm:text-sm lg:text-base font-bold text-center text-blue-500 rounded-lg border border-solid border-[color:var(--Secondary-Blue,#307FE1)]"
        type="button" (click)="viewSimilarParts(product)">
        <span class="text-blue-500"> View Similar Parts </span>
        </button>
        }
    </div>
  </div>
  </article>
</div>
</div>

<div class="flex justify-center tes items-center h-screen" *ngIf="wishlistItems.length === 0">
  No data found
</div>

<!-- Sort By Popup Modal -->
<div *ngIf="showSortPopup" class="fixed inset-0 z-50 flex items-end justify-center max-sm:items-end">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black bg-opacity-50" (click)="closeSortPopup()"></div>

  <!-- Modal Content -->
  <div
    class="relative bg-white rounded-t-2xl w-full max-w-md max-sm:w-full max-sm:max-w-none max-sm:rounded-t-3xl animate-slide-up">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 border-b border-gray-200">
      <h3 class="text-lg font-bold text-gray-900">Sort By</h3>
      <button (click)="closeSortPopup()" class="text-gray-400 hover:text-gray-600">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Options -->
    <div class="p-4">
      <div *ngFor="let option of sortOptions; let last = last" class="py-3">
        <label class="flex items-center cursor-pointer">
          <input type="radio" [name]="'sortOption'" [value]="option.value"
            [checked]="selectedSortOption === option.value" (change)="selectSortOption(option.value)"
            class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
          <span class="ml-3 text-gray-900">{{ option.label }}</span>
        </label>
        <div *ngIf="!last" class="border-t border-gray-200 mt-3"></div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-3 p-4 border-t border-gray-200">
      <button (click)="closeSortPopup()"
        class="flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
        Cancel
      </button>
      <button (click)="applySort()" class="flex-1 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700">
        Apply
      </button>
    </div>
  </div>
</div>

<!-- Filter Popup Modal -->
<div *ngIf="showFilterPopup" class="fixed inset-0 z-50 flex items-end justify-center max-sm:items-end">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black bg-opacity-50" (click)="closeFilterPopup()"></div>

  <!-- Modal Content -->
  <div
    class="relative bg-white rounded-t-2xl w-full max-w-md max-sm:w-full max-sm:max-w-none max-sm:rounded-t-3xl animate-slide-up">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 border-b border-gray-200">
      <h3 class="text-lg font-bold text-gray-900">
        {{ selectedFilterOption }}
      </h3>
      <button (click)="closeFilterPopup()" class="text-gray-400 hover:text-gray-600">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Options -->
    <div class="p-4">
      <div *ngFor="let option of filterOptions; let last = last" class="py-3">
        <label class="flex items-center cursor-pointer">
          <input type="radio" [name]="'filterOption'" [value]="option.value"
            [checked]="selectedFilterOption === option.value" (change)="selectFilterOption(option.value)"
            class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
          <span class="ml-3 text-gray-900">{{ option.label }}</span>
        </label>
        <div *ngIf="!last" class="border-t border-gray-200 mt-3"></div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-3 p-4 border-t border-gray-200">
      <button (click)="closeFilterPopup()"
        class="flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
        Cancel
      </button>
      <button (click)="applyFilter()" class="flex-1 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700">
        Apply
      </button>
    </div>
  </div>
</div>

<!-- Buy Now Popup -->
<app-buy-now-popup [productData]="selectedProductForBuyNow" [isOpen]="isBuyNowPopupOpen"
  [quantity]="getQuantityForPopup(selectedProductForBuyNow)"
  [unit]="selectedProductForBuyNow?.selectedUnit === 'kg' ? 'Kg' : 'Ton'" (close)="closeBuyNowPopup()"
  (paymentSuccess)="onPaymentSuccess($event)">
</app-buy-now-popup>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>